export { default as NumberInput } from './NumberInput';
export type { NumberInputProps } from './types';
